import CONSTANT from '@/constant'
import healthClaimFormAtom from '@/recoil/healthClaimForm'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

export const EditClaimButtonHook = () => {
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const { claimFormId } = useParams<{ claimFormId?: string }>()
  const navigate = useNavigate()
  const isEditable = healthClaim.data?.savePvAction ? false : true

  const redirectToHealthClaimDetailPage = () => {
    const nextPath = CONSTANT.ROUTES.HEALTH_CLAIM_EDIT_PAGE
    const currentPath = CONSTANT.ROUTES.HEALTH_CLAIM_PAGE
    navigate(generatePath(nextPath, { claimFormId }), { state: { referrer: currentPath } })
  }

  return {
    redirectToHealthClaimDetailPage,
    isEditable,
  }
}
